import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rIstatistikPopup } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rIstatistikPopup>,
  rIstatistikPopup
>(ActionSubTypes.API_USTBILGIISTATISTIKDETAY, DefaultInputDataStateModel<pList, rIstatistikPopup>());
